import styled from "styled-components";

export const Container = styled.div`
  padding: 0px 40px 20px 40px;
`;
